<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-backgroundpicker");

    export let backgrounds;
    let resolveResult;

    export function open() {
        jQuery('.GPBackgroundItem').off().on('click',backgroundPickerConfirm);
        jQuery('.GPBackgroundItemYourImagePromo').off().on('click', function() {jQuery('#GPBackgroundPicker').modal('hide'); GPSettings.upgradeClass.showOnlyInPremium("custombg");});
        jQuery('.GPBackgroundItemYourImage').off().on('click', function() {jQuery('#GPBackgroundPicker').modal('hide'); GP.GPUploadBackground();});

        jQuery('#GPBackgroundPicker').modal({});
        jQuery('#GPBackgroundPicker').on('hidden.bs.modal', () => this.$destroy());

        //manage focus
        jQuery('#GPBackgroundPicker').on('show.bs.modal', GP.storeFocus);
        jQuery('#GPBackgroundPicker').on('shown.bs.modal',function (){jQuery('.GPBackgroundList > a.GPBackgroundItem:first-of-type').focus();});
        jQuery('#GPBackgroundPicker').on('hidden.bs.modal', GP.restoreFocus);

        //trap focus
        jQuery('#GPBackgroundPicker .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('#GPBackgroundPicker .GPBackgroundList a:last-of-type').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});

        return new Promise(resolve => {
            resolveResult = resolve;
        })
    }
    
    function backgroundPickerConfirm(e) {
        let selected = jQuery(e.target).closest('.panel').attr('gpbackgroundid');
        resolveResult(selected);
        jQuery('#GPBackgroundPicker').modal('hide');
    }

</script>


<div class="modal fade GPModal" id="GPBackgroundPicker">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Choose background")}</h4>
            </div>
            <div class="modal-body">
                <div class="GPBackgroundList" tabindex='-1'>
                    <div class="panel panel-default GPBackgroundItem GPBackgroundItemYourImage">
                        <img src="img/ios/yourimage.jpg"/>
                        <div class="overlaytext">
                            <i class="fa fa-plus fa-2x"></i><br/>
                            {trans("UPLOAD YOUR PHOTO")}
                        </div>
                    </div>
                    {#each backgrounds as back}
                        {#if back.active}
                            <a href="#" class="panel panel-default GPBackgroundItem" GPBackgroundId="{back.id}" tabindex="0">
                                <img src="{back.thumbSrc}"/>
                            </a>
                        {/if}
                    {/each}
                </div>
                </div>
            <div class="modal-footer">
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->


